























































































































import Vue from 'vue'
import VuePhoneInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

import firebase from 'firebase/app'
import 'firebase/auth'

export default Vue.extend({
  components: {
    VuePhoneInput
  },
  data () {
    return {
      phone: '',
      phoneData: {
        formattedNumber: '',
        formatInternational: '',
        isValid: false
      },
      mfaCode: '',
      recaptchaVerifier: null as firebase.auth.RecaptchaVerifier | null,
      confirmationResult: null as firebase.auth.ConfirmationResult | null,
      error: null as Error | null,
      loading: false
    }
  },
  methods: {
    updatePhoneData (phoneData: any) {
      this.phoneData = phoneData
    },
    async signIn () {
      this.loading = true
      this.error = null

      try {
        if (this.recaptchaVerifier === null) {
          throw new Error('RecatpchaVerifier is null')
        }

        this.confirmationResult = await firebase.auth().signInWithPhoneNumber(this.phoneData.formattedNumber, this.recaptchaVerifier)
      } catch (error) {
        this.error = error
        console.error('Sign in failed: ', error)
      } finally {
        this.loading = false
      }
    },
    async checkPhoneCode () {
      this.loading = true
      this.error = null

      try {
        if (this.confirmationResult === null) {
          throw new Error('Invalid state: captcha confirmation result is null')
        }

        await this.confirmationResult.confirm(this.mfaCode)
      } catch (error) {
        if (error.code === 'auth/invalid-verification-code') {
          this.error = new Error('Invalid code, please check')
          return
        }

        this.error = error
        console.error('Verifying code failed: ', error)
      } finally {
        setTimeout(() => {
          this.loading = false
        }, 800)
      }
    },
    async signInWithLinkedIn () {
      const params = new URLSearchParams()
      params.append('response_type', 'code')
      params.append('client_id', '785gin2ujd8dzt')
      params.append('redirect_uri', 'https://truchecks-na.web.app/oauth/linkedin/callback')
      params.append('scope', 'r_liteprofile r_emailaddress')

      window.location.href = `https://www.linkedin.com/oauth/v2/authorization?${params.toString()}`
    },
    returnToLanding () {
      window.location.href = 'https://truora.com'
    }
  },
  mounted () {
    this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('submit', {
      size: 'invisible'
    })
  }
})
